import { Spinner } from "react-bootstrap";

const Loading = () => {
  return (
    <div className="loading-screen">
      <Spinner animation="border" />
    </div>
  );
};

export default Loading;
